/* eslint-disable @typescript-eslint/naming-convention */
export {
  PageTitles,
  LanguagePage,
  ColumnType,
  FeatureType,
  FilterTypes,
} from '../../interfaces/types';

export enum DropdownCommon {
  selectOption = 'Select an option',
}

export enum TerritoryType {
  coAndFsa = 'CO & FSA',
  cityAndPostal = 'City & Postal Code',
  centralOfficeAbrv = 'co',
  cityAndPostalAbrv = 'co',
}

export enum WalklistType {
  sales = 'Sales',
  dropPermission = 'Drop Permission',
  s = 'S',
  dp = 'D',
}

export enum AccordionType {
  form,
  table,
}

export enum ExcludedProvinces {
  BritishColumbia = 'bc',
  Alberta = 'ab',
}

export enum WalklistFilters {
  doNotKnockInd = 'doNotKnockInd',
  derivedDpStatus = 'derivedDpStatus',
}

export enum SAYB {
  EmptyOrNull = 'Address with no SAYB',
  BookOrder = 'Book Order',
  BookOBDOrder = 'Book OBD Order',
  CheckSecondScreen = 'Check Second Screen',
  NeedFibreDrop = 'Need Fibre Drop',
  RedBarBOSupport = 'Red Bar BO Support',
  RedBarEnggSupport = 'Red Bar Engg Support',
  SellCopperHSOnly = 'Sell Copper HS Only',
  SellCopperwithTV = 'Sell Copper with TV',
  StopExpectFibre = 'Stop: Expect Fibre',
  StopNoPorts = 'Stop: No Ports',
  StopNotQualified = 'Stop: Not Qualified',
  ETTSOldFibre = 'ETTS (Old Fibre)',
}

export enum PremiseType {
  SFU = 'SFU',
  SXU = 'SXU',
  MDU = 'MDU',
  MXU = 'MXU',
  Others = 'Others',
}
